/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

window.Vue = require('vue');
window.moment = require('moment');

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

require('froala-editor/js/froala_editor.pkgd.min');

// Require Froala Editor css files.
require('froala-editor/css/froala_editor.pkgd.min.css');
require('font-awesome/css/font-awesome.css');
require('froala-editor/css/froala_style.min.css');

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'

Vue.use(VueFroala);

import EventBus from './plugins/EventBus.js';

Vue.use(EventBus);

import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll);

import VueLocalStorage from 'vue-ls';

let options = {
    namespace: 'vuejs__'
};
Vue.use(VueLocalStorage, options);

import 'element-theme-chalk'

Vue.use(ElementUI, {locale});

import GoogleDrivePicker from './plugins/GoogleDrive';

Vue.use(GoogleDrivePicker, {
    google_client_id: PS.google.client_id,
    projects_folder: PS.google.projects_folder,
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('filter-date', require('./components/FilterDate.vue'));

Vue.component('ProjectDescription', require('./components/projects/ProjectDescription.vue'));
Vue.component('ProjectNotes', require('./components/projects/ProjectNotes.vue'));
Vue.component('ProjectTypeLabel', require('./components/projects/ProjectTypeLabel.vue'));
Vue.component('ProjectBudgetList', require('./components/projects/ProjectBudgetList.vue'));
Vue.component('ProjectTickList', require('./components/projects/ProjectTickList.vue'));
Vue.component('ProjectReports', require('./components/projects/Reports.vue'));

Vue.component('TaskDescription', require('./components/tasks/TaskDescription.vue'));
Vue.component('TaskModalDone', require('./components/tasks/TaskModalDone.vue'));
Vue.component('TaskTracker', require('./components/tasks/TaskTracker.vue'));
Vue.component('task-trackers', require('./components/tasks/TaskTrackers.vue'));
Vue.component('task-activity', require('./components/tasks/TaskActivity.vue'));
Vue.component('task-one-time-switcher', require('./components/tasks/TaskOneTimeSwitcher.vue'));
Vue.component('task-timers', require('./components/tasks/TaskTimers.vue'));
Vue.component('task-tracking-timers', require('./components/tasks/TaskTrackingTimers.vue'));
Vue.component('EhSlider', require('./components/tasks/EhSlider.vue'));

Vue.component('user-hours', require('./components/users/UserHours.vue'));

Vue.component('ClientCommunication', require('./components/clients/ClientCommunication.vue'));

Vue.component('SearchBar', require('./components/Header/SearchBar.vue'));

Vue.component('ProjectDataStudioReportsEdit', require('./components/projects/ProjectDataStudioReportsEdit.vue'));

Vue.component('Gantt', require('./components/gantt/Gantt'));
Vue.component('GanttMenu', require('./components/gantt/GanttMenu'));


if (document.getElementById('app')) {
    window.vueApp = new Vue({
        el: '#app',
    });
}
if (document.getElementById('header')) {
    window.headerApp = new Vue({
        el: '#header',
    });
}
import Holder from 'holderjs';

Holder.addTheme("visi", {
    bg: "#f49996",
    fg: "#fff",
    size: 11,
    font: "Monaco",
    fontweight: "normal"
});
Holder.run();


// WEBPACK FOOTER //
// ./resources/assets/js/app.js